import React, { forwardRef, useImperativeHandle, useState, useEffect } from 'react';
import { Form, Input, Select, Row, Col, TimePicker, Typography, Button,DatePicker } from 'antd';
import { getAllEvents } from '../../services/selfOnboarding';
import { getCrewAll,getLabourCategories } from '../../services/crew';
import dayjs from 'dayjs';

const { Option } = Select;
const { Title } = Typography;

const BasicDetails = forwardRef(({ onChange, onNext, initialValues }, ref) => {
  const [form] = Form.useForm();

  // Expose validate method to parent
  useImperativeHandle(ref, () => ({
    validate: () => form.validateFields(),
  }));

  const data = [
  { key: 1, name: 'John Smith', id: 'E1001', union: 'Local 12', ssn4: '1234', task: 'Welding', trade: 'Welder' },
  { key: 2, name: 'Sarah Johnson', id: 'E1002', union: 'Local 10', ssn4: '5678', task: 'Plumbing', trade: 'Plumber' },
  { key: 3, name: 'David Lee', id: 'E1003', union: 'Local 12', ssn4: '9012', task: 'Carpentry', trade: 'Carpenter' },
  { key: 4, name: 'Maria Garcia', id: 'E1004', union: 'Local 13', ssn4: '1122', task: 'Electrical', trade: 'Electrician' },
  { key: 5, name: 'Ahmed Khan', id: 'E1005', union: 'Local 16', ssn4: '3344', task: 'HVAC', trade: 'Technician' },
  { key: 6, name: 'Emily Davis', id: 'E1006', union: 'Local 18', ssn4: '7788', task: 'Welding', trade: 'Welder' },
  { key: 7, name: 'Michael Brown', id: 'E1007', union: 'Local 20', ssn4: '9900', task: 'Carpentry', trade: 'Carpenter' },
  { key: 8, name: 'Rachel Green', id: 'E1008', union: 'Local 15', ssn4: '2244', task: 'Painting', trade: 'Painter' },
  { key: 9, name: 'Chris Evans', id: 'E1009', union: 'Local 18', ssn4: '5566', task: 'Plumbing', trade: 'Plumber' },
  { key: 10, name: 'Olivia Wilson', id: 'E1010', union: 'Local 09', ssn4: '7788', task: 'Electrical', trade: 'Electrician' },
  { key: 11, name: 'Ethan Hall', id: 'E1011', union: 'Local 22', ssn4: '9911', task: 'Carpentry', trade: 'Carpenter' },
  { key: 12, name: 'Isabella Martinez', id: 'E1012', union: 'Local 12', ssn4: '3322', task: 'Welding', trade: 'Welder' },
  { key: 13, name: 'Liam Thomas', id: 'E1013', union: 'Local 26', ssn4: '4433', task: 'HVAC', trade: 'Technician' },
];

  // Only send fields that have a value (not undefined)
  const handleValuesChange = (_, allValues) => {
    const filtered = {};
    Object.keys(allValues).forEach(key => {
      if (
        allValues[key] !== undefined &&
        allValues[key] !== null &&
        allValues[key] !== ''
      ) {
        filtered[key] = allValues[key];
      }
    });
    if (onChange) onChange(filtered);
  };

  const [events, setEvents] = useState([]);
  const [crewTemplates, setCrewTemplates] = useState([]);
  const [crewTemplateMap, setCrewTemplateMap] = useState({});
  const [task, setTask] = useState([]);
  const [premium, setPremium] = useState([]);
  const [venue, setVenue] = useState([]);
  const [eventName, setEventName] = useState([]);
    const [payScale, setPayscale] = useState([]);






  useEffect(() => {
    fetchEvents();
    fetchCrewAll();
    fetchLabourCategories()
  }, []);

  const fetchEvents = async () => {
    try {
      const response = await getAllEvents();
      setEvents(response.data?.events || []);
    } catch (error) {
      console.error('Error fetching events:', error);
    }
  };

  const fetchCrewAll = async () => {
    try {
      const response = await getCrewAll();
      const crews = response.data?.data || [];
      // Build unique template list and a map for quick lookup
      const templateMap = {};
      const templateList = [];
      crews.forEach(c => {
        // Use crewTemplate if present, else fallback to crewTemplateName as unique key
        const key = c.crewTemplate || c.crewTemplateName;
        if (key && !templateMap[key]) {
          templateMap[key] = c;
          templateList.push({
            value: key,
            label: c.crewTemplateName || c.crewTemplate || key,
            data: c
          });
        }
      });
      setCrewTemplates(templateList);
      setCrewTemplateMap(templateMap);
    } catch (error) {
      console.error('Error fetching crew templates:', error);
    }
  };

  const fetchLabourCategories = async () => {
    try {
      const response = await getLabourCategories();
      const task_subTask = response?.data?.task_sub_task || [];
      const Premium = response?.data?.payscale_group || [];
      const Venue = response?.data?.branch_pa_cost_center || [];
      const EventName = response?.data?.wbs_io || [];
      const Payscale = response?.data?.level || [];






      setTask(task_subTask);
      setPremium(Premium);
      setVenue(Venue);
      setEventName(EventName);
      setPayscale(Payscale);
      console.log("ressss",response);
      
    } catch (error) {
      console.error('Error fetching crew templates:', error);
    }
  };
  console.log("taskkkkkk",task);

  // When Crew Template changes, set fields from template
  const handleCrewTemplateChange = (value) => {
    const template = crewTemplateMap[value];
    if (template) {
      const parseTime = (t) => {
        if (!t) return undefined;
        if (typeof t === 'string' && t.length > 10) {
          const d = dayjs(t);
          return d.isValid() ? d : undefined;
        }
        return t;
      };
      const {
        crewTemplate,
        crewTemplateName,
        crewName,
        crewLead,
        supervisor,
        task,
        premium,
        numEmployees,
        startTime,
        endTime,
        venue,
        payScale,
        eventName,
        eventDescription
      } = template;
      form.setFieldsValue({
        crewTemplate: crewTemplate || crewTemplateName,
        crewTemplateName,
        crewName,
        crewLead,
        supervisor,
        task,
        premium,
        numEmployees,
        startTime: parseTime(startTime),
        endTime: parseTime(endTime),
        venue,
        payScale,
        eventName,
        eventDescription
      });
      handleValuesChange(null, {
        crewTemplate: crewTemplate || crewTemplateName,
        crewTemplateName,
        crewName,
        crewLead,
        supervisor,
        task,
        premium,
        numEmployees,
        startTime: parseTime(startTime),
        endTime: parseTime(endTime),
        venue,
        payScale,
        eventName,
        eventDescription
      });
    }
  };

  return (
    <Form
      layout="vertical"
      form={form}
      initialValues={initialValues}
      onValuesChange={handleValuesChange}
      autoComplete="off"
      onKeyDown={e => {
        if (e.key === 'Enter') e.preventDefault();
      }}
    >
      {/* Crew Template */}
      <Row gutter={16}>
        <Col span={6}>
          <Form.Item
            label="Crew Template"
            name="crewTemplate"
          >
            <Select
              placeholder="Select Crew Template"
              onChange={handleCrewTemplateChange}
              allowClear
            >
              {crewTemplates.map(tpl => (
                <Option key={tpl.value} value={tpl.value}>
                  {tpl.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      {/* Crew & Supervision */}
      <Title level={5} style={{ marginTop: 24, marginBottom: 16 }}>Crew & Supervision</Title>
      <Row gutter={16}>
        <Col span={6}>
          <Form.Item
            label="Crew Template Name"
            name="crewTemplateName"
          >
            <Input placeholder="Electricians" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Crew Name*"
            name="crewName"
            rules={[{ required: true, message: 'Crew Name is required' }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Crew Lead"
            name="crewLead"
          >
                <Select placeholder="Select Crewlead">

            {data.map((task) => (
        <Select.Option key={task.id} value={task.id}>
          {task.name}
              </Select.Option>
              
            ))}
              </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Supervisor"
            name="supervisor"
          >
                        <Input />

          </Form.Item>
        </Col>
      </Row>
      {/* Work Details */}
      <Title level={5} style={{ marginTop: 24, marginBottom: 16 }}>Work Details</Title>
      <Row gutter={16}>
       <Col span={6}>
  <Form.Item
    label="Task"
    name="task"
  >
    <Select placeholder="Select Task">
      {task.map((task) => (
        <Select.Option key={task.id} value={task.name}>
                           {task.name + " - " + task.description}

        </Select.Option>
      ))}
    </Select>
  </Form.Item>
</Col>

        <Col span={6}>
          <Form.Item
            label="Premium"
            name="premium"
          >
<Select placeholder="Select Premium">
      {premium.map((task) => (
        <Select.Option key={task.id} value={task.name}>
                           {task.name + " - " + task.description}

        </Select.Option>
      ))}
    </Select>          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="No. of Employees needed"
            name="numEmployees"
          >
            <Input type="number" placeholder="6" />
          </Form.Item>
        </Col>
      </Row>
      {/* Shift Timings */}
      <Title level={5} style={{ marginTop: 24, marginBottom: 16 }}>Shift Timings</Title>
      <Row gutter={16}>
        <Col span={6}>
          <Form.Item
            label="Start Time*"
            name="startTime"
            rules={[{ required: true, message: 'Start Time is required' }]}
          >
            <TimePicker format="HH:mm" style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="End Time*"
            name="endTime"
            rules={[{ required: true, message: 'End Time is required' }]}
          >
            <TimePicker format="HH:mm" style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Date" name="date" rules={[{ required: true, message: 'Date is required' }]}>
            <DatePicker style={{ width: '100%' }} format="DD-MM-YYYY" />
          </Form.Item>
        </Col>
      </Row>
      {/* Location & Compensation */}
      <Title level={5} style={{ marginTop: 24, marginBottom: 16 }}>Location & Compensation</Title>
      <Row gutter={16}>
        <Col span={6}>
          <Form.Item
            label="Venue"
            name="venue"
            rules={[{ required: true, message: 'Venue is required' }]}
          >
           <Select placeholder="Select Venue">
      {venue.map((task) => (
        <Select.Option key={task.id} value={task.name}>
                           {task.name + " - " + task.description}

        </Select.Option>
      ))}
    </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Pay Scale"
            name="payScale"
          >
<Select placeholder="Select Payscale">
      {payScale.map((task) => (
        <Select.Option key={task.id} value={task.name}>
                 {task.name + " - " + task.description}
        </Select.Option>
      ))}
    </Select>          </Form.Item>
        </Col>
      </Row>
      {/* Event Details */}
      <Title level={5} style={{ marginTop: 24, marginBottom: 16 }}>Event Details</Title>
      <Row gutter={16}>
        <Col span={6}>
          <Form.Item
            label="Event Name"
            name="eventName"
            rules={[{ required: true, message: 'Event Name is required' }]}
          >
            {/* <Select placeholder="Select Event">
              {events.map(ev => (
                <Option key={ev._id} value={ev.name}>
                  {ev.name} {ev.startDate ? `(${ev.startDate})` : ''}
                </Option>
              ))}
            </Select> */}
            <Select placeholder="Select Event Name">
               {eventName.map((task) => (
               <Select.Option key={task.id} value={task.name}>
                 {task.name + " - " + task.description}
                </Select.Option>
      ))}
    </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Event Description"
            name="eventDescription"
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24} style={{ textAlign: 'right', marginTop: 24 }}>
          <Button type="primary" onClick={onNext}>
            Next
          </Button>
        </Col>
      </Row>
    </Form>
  );
});

export default BasicDetails;

